import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadLoginList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations/${options.organisationId}/staffs${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
  adddLogin: async (options = {}) => {
    const result = await axios.post(
      `${baseUrl}/customer/mob/login_staffs`,
      options.data,
    );
    return result.data;
  },
  updateLogin: async (options = {}) => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/staffs/${options.staffId}`,
      options.data,
    );
    return result.data;
  },
  changeStatusLogin: async (options = {}) => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/staffs/${options.staffId}/status`,
      options.data,
    );
    return result.data;
  },
  changePasswordLogin: async (options = {}) => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/staffs/${options.staffId}/change_password`,
      options.data,
    );
    return result.data;
  },
};
